import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Shuffle } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const RTL = ['ar', 'fa'];
const shuffle = (n) => [...Array(n).keys()].sort(() => Math.random() - 0.5);

export const StagedPreviewModal = ({ question, onClose }) => {
  const langs = question ? Object.keys(question.question || {}).filter((k) => question.question[k]) : [];
  const [lang, setLang] = useState('sv');
  const [order, setOrder] = useState([]);
  const [picked, setPicked] = useState(null);
  const opts = question?.options?.[lang] || [];

  useEffect(() => { setPicked(null); setOrder(shuffle(opts.length)); }, [question, lang, opts.length]);
  useEffect(() => { setLang('sv'); }, [question]);
  if (!question) return null;
  const correct = question.correct_answer;
  const img = question.image_url && (question.image_url.startsWith('http') ? question.image_url : `${API_URL}${question.image_url}`);

  return (
    <Dialog open={!!question} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-xl max-h-[90vh] overflow-y-auto" data-testid="staged-preview-modal">
        <DialogHeader><DialogTitle>Förhandsvisning / معاينة</DialogTitle></DialogHeader>
        <div className="flex flex-wrap gap-1.5">
          {langs.map((l) => (
            <button key={l} type="button" onClick={() => setLang(l)} data-testid={`preview-lang-${l}`}
              className={`px-2.5 py-1 rounded-md text-xs font-bold border ${lang === l ? 'bg-emerald-500 text-white border-emerald-500' : 'border-slate-200'}`}>{l.toUpperCase()}</button>
          ))}
          <button type="button" onClick={() => { setPicked(null); setOrder(shuffle(opts.length)); }} className="ms-auto text-slate-500" aria-label="shuffle" data-testid="preview-shuffle"><Shuffle className="w-4 h-4" /></button>
        </div>
        <div dir={RTL.includes(lang) ? 'rtl' : 'ltr'} className="space-y-3">
          {img && <img src={img} alt="" className="max-h-56 mx-auto rounded-lg object-contain" />}
          {question.video_url && (
            <video src={question.video_url.startsWith('http') ? question.video_url : `${API_URL}${question.video_url}`} controls playsInline
              className="w-full max-h-64 rounded-lg bg-black" data-testid="preview-video" />
          )}
          <p className="font-semibold whitespace-pre-line" data-testid="preview-question">{question.question[lang]}</p>
          <div className="grid gap-2">
            {order.map((i) => {
              const state = picked === null ? '' : i === correct ? 'bg-emerald-500 text-white border-emerald-500' : i === picked ? 'bg-rose-500 text-white border-rose-500' : 'opacity-60';
              return (
                <button key={i} type="button" disabled={picked !== null} onClick={() => setPicked(i)} data-testid={`preview-option-${i}`}
                  className={`text-start rounded-lg border border-slate-200 px-3 py-2 text-sm ${state}`}>{opts[i]}</button>
              );
            })}
          </div>
          {picked !== null && question.explanation?.[lang] && (
            <p className="rounded-lg bg-slate-50 p-3 text-sm whitespace-pre-line" data-testid="preview-explanation">{question.explanation[lang]}</p>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
